var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"padding",rawName:"v-padding:large",arg:"large"}]},[_c('FdPopover',[_c('FdCalendar',{attrs:{"slot":"body"},slot:"body"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }